"use strict";

import Vue from 'vue';
import axios from "axios";
import VueCookies from 'vue-cookie';
import router from '../router';
import { message } from "ant-design-vue";
import qs from 'qs';
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || "http://workorder.jisuapp.cn",
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control 
  transformRequest: [function (data) {
    // 将数据转换为表单数据 
    return qs.stringify(data)
  }],
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    if (response.data.status == 2) {
      message.error(response.data.data);
      VueCookies.delete('is_login');
      router.push('login');
    }
    if (response.data.status == 1) {
      message.error(response.data.data);
    }
    return response;
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
